$(function() {
    var $el = $('.heroslider-zoom-animation');
    $(window).on('scroll', function () {
        var scroll = $(document).scrollTop();

        $el.css({
            'background-size': (scroll > 0 ? 100 + ((scroll / 9.99) / 2) : '100') + '%'
        });
	    
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/hero-slider.js
// module id = 20
// module chunks = 0